<template>
  <nv-page header="Connected Devices Rules" data-cy="ottm-rules-list">
    <template #toolbar>
      <v-spacer />
      <nv-table-search v-model="search" sync />
    </template>

    <template #filters>
      <nv-table-filters
        ref="applied-filters"
        :value="tableFilters"
        @clear="$refs['filter-sheet'].clearFilters()"
      >
        <rules-filter-sheet ref="filter-sheet" @changed="setTableFilters" />
      </nv-table-filters>
    </template>

    <v-data-table
      :headers="headers"
      :items="extendedItems"
      :loading="loading"
      :options.sync="table"
      :server-items-length="totalItems"
      :footer-props="footerProps"
      :items-per-page.sync="table.itemsPerPage"
    >
      <template #item="{ item }">
        <tr>
          <td>
            <router-link :to="{ name: 'owl.ottm.rules.show', params: { ruleId: item.id } }">
              {{ item.pattern }}
            </router-link>
          </td>
          <td>{{ item.tree_id }}</td>
          <td>
            <CountryBadge :country="resolveCountryCode(item.localization)" />
          </td>
          <td>
            <tree-item v-if="item.channel && item.channel.id" :item="item.channel" />
            <span v-else>Unavailable</span>
          </td>
          <td>{{ item.property | humanize }}</td>
          <td>{{ item.status | humanize }}</td>

          <td>
            <updated-details :item="item" />
          </td>

          <td class="text-end">
            <v-btn v-if="$auth.hasPermissions('ant.discovery')" icon @click="openForm(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <rules-edit-form v-model="form.show" :editing="form.edit" @saved="tableFetch" />
  </nv-page>
</template>

<script>
import RulesList from '@/components/cls/RulesList';
import RulesEditForm from '@/components/cls/connected-devices/RulesEditForm';
import RulesFilterSheet from '@/components/cls/connected-devices/RulesFilterSheet.vue';
import TreeItem from '@/components/cls/TreeItem.vue';
import UpdatedDetails from '@/components/cls/UpdatedDetails.vue';
import CountryBadge from '@/components/CountryBadge';
import { resolveCountryCode } from '@/helpers/filters';

const headers = [
  { text: 'Rule', sortable: false, value: 'pattern' },
  { text: 'Tree ID', sortable: false, value: 'tree_id' },
  { text: 'Market', sortable: false, value: 'localization' },
  { text: 'Level', sortable: false, value: 'channel' },
  { text: 'Property', sortable: false, value: 'property' },
  { text: 'Status', sortable: false, value: 'status' },
  { text: 'Updated', sortable: false, value: 'updated_by' },
  { sortable: false, value: 'edit', align: 'end' },
];

export default {
  components: { UpdatedDetails, TreeItem, RulesFilterSheet, RulesEditForm, CountryBadge },
  extends: RulesList('ottm'),
  data: () => ({
    headers,
  }),
  methods: {
    resolveCountryCode,
  },
};
</script>
